var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05286 8.1332C8.05286 7.15863 8.81077 6.42857 10 6.42857C11.1892 6.42857 11.9471 7.15863 11.9471 8.1332C11.9471 8.54647 11.8275 8.80511 11.669 9.00577C11.4911 9.23089 11.2418 9.41477 10.894 9.65378C10.8649 9.67384 10.8349 9.6943 10.8042 9.7152C10.1578 10.1563 9.2175 10.798 9.2175 12.1429C9.2175 12.5373 9.56512 12.8571 9.99393 12.8571C10.4227 12.8571 10.7704 12.5373 10.7704 12.1429C10.7704 11.5352 11.1036 11.293 11.8235 10.7982C12.1581 10.5682 12.5912 10.2684 12.9251 9.84569C13.2784 9.39857 13.5 8.84533 13.5 8.1332C13.5 6.33611 12.0099 5 10 5C7.99007 5 6.5 6.33611 6.5 8.1332C6.5 8.52769 6.84762 8.84749 7.27643 8.84749C7.70524 8.84749 8.05286 8.52769 8.05286 8.1332Z",
    fill: "#50525A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10.4296 15 10.7778 14.6802 10.7778 14.2857C10.7778 13.8912 10.4296 13.5714 10 13.5714C9.57045 13.5714 9.22222 13.8912 9.22222 14.2857C9.22222 14.6802 9.57045 15 10 15Z",
    fill: "#50525A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#50525A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.svg";
export { ForwardRef as ReactComponent };